import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  scrollTo?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  onClick,
  type = 'button',
  disabled = false,
  scrollTo
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none cursor-pointer active:scale-95 hover:scale-[1.02]';
  const variants = {
    primary: 'bg-[#2c4a2c] text-white hover:bg-[#3d663d] shadow-md hover:shadow-lg',
    secondary: 'bg-[#c45d3a] text-white hover:bg-[#a84a2a] shadow-sm',
    outline: 'border-2 border-[#2c4a2c] text-[#2c4a2c] hover:bg-[#2c4a2c]/5',
    ghost: 'text-[#2c4a2c] hover:bg-[#2c4a2c]/5 hover:text-[#3d663d]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const handleClick = () => {
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  return <button type={type} onClick={handleClick} disabled={disabled} className={cn(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className)} data-id="element-335">
      {children}
    </button>;
}